export default {
    login: {
        please_login: 'Please login first'
    },
    user: {
        center: 'User Center',
        info: 'Personal Information',
        address: 'Address management',
        footprint: 'Footprint',
        coupon: 'Coupons',
        order: 'My Order',
        evaluate: 'Reviews',
        aftersale: 'After-sale records',
        transaction: 'Transaction Center',
        noCoupons: 'No coupons available'
    },
    common: {
        all: 'All',
        home: 'Home',
        notice: 'Notice',
        announcement: 'Announcement',
        systemNotice: 'System Notice',
        success: 'Success',
        fail: 'Fail',
        receive: 'Receive',
        received: 'Received',
        receiveSuccess: 'Received successfully',
        deleteSuccess: 'Deleted successfully',
        verifyCodeSuccess: 'Verification code sent successfully',
        noInfo: 'No information',
        category: 'Category',
        networkError: 'Network Error',
        noData: 'No data available'
    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js